import React, { useState, useContext, useEffect, Fragment } from 'react'
import { PageContext } from '../../Context/PageProvider'
import { makeStyles } from '@material-ui/core/styles'
import { DefaultStyles } from '../../Stylesheet/theme'
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import { TextValidator } from 'react-material-ui-form-validator'
import Modal from './Modal'

function RoleModal({ t, role, open, onClose }) {
    const classes = useStyles()
    const contex = useContext(PageContext)
    const api = contex.api
    const [editRole, setEditRole] = useState(null)
    const [loading, setLoading] = useState(false)

    if (editRole === null) {
        setEditRole(role ? { ...role } : { title: '', description: '', permissions: ['view-baths'] })
    }

    const onSubmit = async () => {
        try {
            setLoading(true)
            role ? await api.adminService.updateRole(editRole) : await api.adminService.addRole(editRole)
            setTimeout(() => {
                onClose()
            }, 500)
        } catch (error) {
            console.log('Role Modal Error,', error)
        }
    }

    if (editRole === null) return null
    return (
        <Modal open={open} aria-labelledby="role-modal" title={role ? t('edit_role') : t('new_role')} onSubmit={onSubmit} onCancel={onClose} loading={loading}>
            <Grid container>
                <Grid item className={classes.fields}>
                    <TextValidator
                        label={t('title')}
                        onChange={(event) => { const value = event && event.target && event.target.value; setEditRole(prevState => ({ ...prevState, title: value })) }}
                        name="role-title"
                        type="text"
                        validators={['required']}
                        errorMessages={[t('this_field_is_required')]}
                        value={editRole.title}
                        disabled={loading}
                    />
                </Grid>
                <Grid item className={classes.fields}>
                    <TextValidator
                        label={t('description')}
                        onChange={(event) => { const value = event && event.target && event.target.value; setEditRole(prevState => ({ ...prevState, description: value })) }}
                        name="role-description"
                        type="text"
                        validators={['required']}
                        errorMessages={[t('this_field_is_required')]}
                        value={editRole.description}
                        disabled={loading}
                    />
                </Grid>
            </Grid>
        </Modal >
    )
}

const useStyles = makeStyles(theme => ({
    fields: {
        ...DefaultStyles.ModalFields,
        marginBottom: theme.margin.medium,
        marginRight: 0
    },
}))

export default (withTranslation()(RoleModal))